import { JSX } from 'react';
import { Span } from 'shared-components';
import { ApplicantOfferRequirementTask, IInternalDocumentData } from 'api-paths-cas';
import { getFulfilmentProp } from '@/utilities/fulfilmentData';
import FormattedFulfilmentData, { PreviewLink } from '../../FormattedFulfilmentData';
import { ApplicationState } from '@/store';

export interface FulfilmentRendererProps {
  fulfilmentData: unknown;
  requirementId: string;
  taskType?: ApplicantOfferRequirementTask;
  application: ApplicationState['apply']['application'];
  openFile: (urls: string[]) => void;
  taskText?: string;
  isMultiQualification?: boolean;
  internalData?: IInternalDocumentData | null;
}

export default function BaseFulfilmentDataRenderer({
  fulfilmentData,
  requirementId,
  taskType,
  application,
  openFile,
  taskText,
  isMultiQualification,
  internalData,
}: FulfilmentRendererProps): JSX.Element {
  const s3Keys = getFulfilmentProp(fulfilmentData, 's3Keys');
  const hasS3Keys = Array.isArray(s3Keys) && s3Keys.length > 0;
  const hasOtherContent =
    !s3Keys &&
    (getFulfilmentProp(fulfilmentData, 'studyHistory') ||
      getFulfilmentProp(fulfilmentData, 'text') ||
      getFulfilmentProp(fulfilmentData, 'englishTest'));
  const hasInternalFiles = internalData?.urls && internalData.urls.length > 0;

  return (
    <>
      {fulfilmentData && (hasS3Keys || hasOtherContent) && (
        <FormattedFulfilmentData
          fulfilmentData={fulfilmentData}
          preview={openFile}
          requirementId={requirementId}
          taskType={taskType}
          application={application}
          taskText={taskText}
          isMultiQualification={isMultiQualification}
        />
      )}

      {getFulfilmentProp(fulfilmentData, 'sKey') && !s3Keys && (
        <Span color="muted">Link to document not available</Span>
      )}

      {hasInternalFiles && (
        <PreviewLink
          preview={openFile}
          urls={internalData.urls}
          text="Internal document"
          count={internalData.urls.length}
        />
      )}
    </>
  );
}
